import { PosGetItem } from '@/domain/models/Pos';
import { errorHandler } from '@/lib/ErrorHandler';
import { getClient } from '@/lib/restClient';
import { getParams, PosService } from '@/services/Pos';

// interface PosItems {
//   posGetItem?: PosGetItem;
//   isLoading: boolean;
//   isError: Error | null;
// }

export const usePos = async (params: getParams): Promise<PosGetItem> => {
  const posService = new PosService(getClient());

  return posService
    .fetch(params)
    .catch((error: Error) => errorHandler({ error }));

  // const {
  //   data: posGetItem,
  //   error,
  //   isLoading,
  //   isFetching,
  //   isPreviousData,
  // } = useQuery<PosGetItem, Error>(
  //   ['posItems', params],
  //   () => {
  //     return posService
  //       .fetch(params)
  //       .catch((error: Error) => errorHandler({ error }));
  //   },
  //   { keepPreviousData: true }
  // );

  // return {
  //   posGetItem,
  //   isLoading: isLoading || (isFetching && isPreviousData),
  //   isError: error,
  // };
};
